module.exports = __webpack_public_path__ + "static/media/code.f83a50f5.svg";